import React from 'react'
import { useDialog } from '../hooks/useDialog'
import { IconButton } from '../ui/Icon'
import { STILL_DUE, TURN_OFF_ASK, TURN_OFF_CARD_PAYMENTS, keepLabel, turnOffLine } from './rungs'
import '../components/Sheet.css'
import './billing.css'

interface Props {
  // endsOn is the period's end, "13 November", for the line.
  endsOn: string | null
  // overdue: her last payment failed; it stays due after she turns them off.
  overdue?: boolean
  busy: boolean
  error?: string
  onConfirm: () => void
  onClose: () => void
}

// TurnOffPaymentsSheet is the question Turn off card payments opens on the
// Payments plan (owner, 2026-10-25), the shape of Cancel Pro's: what stops
// and when, the one red confirmation, and the way back (Keep card payments
// on) as a full-width secondary button, the app's danger pattern (docs/25).
// It renders in place, like Settings' other sheets.
export default function TurnOffPaymentsSheet({ endsOn, overdue = false, busy, error = '', onConfirm, onClose }: Props) {
  const dialogRef = React.useRef<HTMLDivElement>(null)
  useDialog(dialogRef, onClose, { closable: !busy })
  return (
    <div className="sheet-overlay" onClick={() => { if (!busy) onClose() }}>
      <div
        ref={dialogRef}
        className="sheet-content sheet-content--closable rung-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={TURN_OFF_ASK}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet-handle"></div>
        <IconButton icon="close" label="Close" className="sheet-close" onClick={onClose} disabled={busy} />
        <div className="sheet-header sheet-header--closable">
          <h2>{TURN_OFF_ASK}</h2>
          <p>{turnOffLine(endsOn)}{overdue && ` ${STILL_DUE}`}</p>
        </div>
        <div className="sheet-body">
          {error && <p className="field-error" role="alert">{error}</p>}
          <div className="sheet-stack">
            <button type="button" className="btn btn-danger-solid btn-block" onClick={onConfirm} disabled={busy}>
              {busy ? 'Turning off…' : TURN_OFF_CARD_PAYMENTS}
            </button>
            <button type="button" className="btn btn-secondary btn-block" onClick={onClose} disabled={busy}>
              {keepLabel('card_payments')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
